export default __webpack_public_path__ + "static/media/tolerance.864f870b.svg";